import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import ModalContainer from "../../containers/shared/ModalContainer";
import { UserContext } from "../../App";
import { getDatabase, ref, onChildAdded } from 'firebase/database';
import { getApp, getApps, initializeApp } from 'firebase/app';

const NotificationsCenterPage = () => {

    const firebaseConfig = {
      apiKey: "AIzaSyCr6qJuyOgqLtNjcbVNV09x7eMdgYPCCZI",
      authDomain: "fanniapp-bdcf4.firebaseapp.com",
      databaseURL: "https://fanniapp-bdcf4.firebaseio.com",
      projectId: "fanniapp-bdcf4",
      storageBucket: "fanniapp-bdcf4.appspot.com",
      messagingSenderId: "591978559350",
      appId: "1:591978559350:web:df9a05b421f33c831c6c57",
      measurementId: "G-EXML4S483L"
    };

    const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
    const db = getDatabase(app);
    

    const { notificationsStatus, setNotificationsStatus } = useContext(UserContext);
    const {t,i18n} = useTranslation();
    useDocumentTitle('مركز التنبيهات');
    const [userData, setUserData] = useState(null);
    const pageTitle = {title: 'مركز التنبيهات', subTitle: 'يمكنك متابعة التنبيهات المرسلة لك من المالك'};
    const [notifications, setNotifications] = useState(null);

    const [selectedNotification, setSelectedNotification] = useState(null);
    const [showNotificationDetailsModal, setShowNotificationDetailsModal] = useState(false);
    const [isNotificationsFetched, setIsNotificationsFetched] = useState(false);

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const getNotifications = async () => {
      try {
        const response = await apiClient.get(`/b-notifications`);
        if(response?.data) {
          setNotifications(response?.data);
          setIsNotificationsFetched(true);
          setNotificationsStatus(response?.data?.filter(notification => notification?.isRead === false)?.length > 0);
        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(setNotificationsStatus) {
            getNotifications();
        }
    },[setNotificationsStatus]);

    const markAllRead = async () => {
        try {
            const response = await apiClient.patch(`/b-notifications/mark-all-as-read`);
            if(response?.data) {
                getNotifications();
            }
        } catch(err) {}
    }

    const markNotificationAsRead = async (id) => {
        try {
            const response = await apiClient.patch(`/b-notifications/mark-as-read${id}`);
            if(response?.data) {
                getNotifications();
            }
        } catch(err) {}
    }

    const showNotificationDetails = (item) => {
        markNotificationAsRead(item?._id);
        setSelectedNotification(item);
        setShowNotificationDetailsModal(true);
    }

    const handleCloseModal = () => {
        setShowNotificationDetailsModal(false);
    }

    useEffect(()=>{
        if(userData?._id && isNotificationsFetched) {
            const notificationsRef = ref(db, `dev/notifications/${userData?._id}`);
            const unSubscribeAdd = onChildAdded(notificationsRef, (snapshot,prev) => {
                const newData = snapshot.val();
                // console.log(newData);
                // console.log(notifications?.filter(item=> item?._id === newData?.id).length > 0)
               if(notifications?.filter(item=> item?._id === newData?.id).length === 0) {
                   newData.title = newData.title.ar;
                   newData.body = newData.body.ar;
                   setNotifications([newData, ...notifications]);
               }
            });

            return () => {
            unSubscribeAdd();
            };
        }
    },[userData?._id,isNotificationsFetched])

    return (
        <div>
            <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
            <PageMain>
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <MainContent>
                    {notifications && Array.isArray(notifications) && notifications?.length > 0 ? <>
                        <div className="flex flex-nowrap bg-white rounded-[8px] p-[16px] mb-[25px]">
                            <div className="w-[50%] text-grey-900 font-[500] text-[20px]">كل التنبيهات {notifications?.filter(item=> item?.isRead === false).length > 0 ? <span className="text-orange">{`(${notifications?.filter(item=> item?.isRead === false).length} غير مقروء)`}</span> : ``}</div>
                            <div className="w-[50%] text-end">{notifications?.filter(item=> item?.isRead === false).length > 0 && <div className="inline-block text-blue cursor-pointer select-none font-[500] text-[16px]" onClick={()=>markAllRead()}>تحديد الكل كمقروء</div>}</div>
                        </div>
                        {
                            notifications?.map((item,index)=>{
                                return (
                                    <div key={`notification-${index}`} className={`flex flex-nowrap rounded-[8px] p-[16px] mt-[15px] ${item?.isRead ? 'bg-white' : 'bg-lightBlue'}`}>
                                        <div className="w-[80%] text-grey-900 font-[500] text-[20px]">
                                            <div className="font-[500] text-[18px] text-grey-900 mb-[15px]">{item?.title}</div>
                                            <div className="font-[500] text-[16px] text-grey-600 whitespace-nowrap overflow-hidden text-ellipsis">{item?.body}</div>
                                        </div>
                                        <div className="w-[20%] text-end">
                                            <div className="font-[500] text-[18px] text-darkBlue mb-[15px] text-end"><div className="inline-block underline cursor-pointer select-none" onClick={()=>showNotificationDetails(item)}>قراءة المزيد</div></div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </>
                    : <>
                    <div className="pt-[80px] text-center relative z-10">
                        <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/notification-status.svg')"}}></div>
                        <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لايوجد أي تنبيهات حتي الأن</div>
                    </div>
                    </>}
                </MainContent>
                
               
            </PageMain>

            { showNotificationDetailsModal && <ModalContainer heading="تفاصيل التنبيه" handleCloseModal={handleCloseModal}>
                <div className="border-t-[1px] border-t-grey-100 pt-[15px]"></div>
                <p className="text-grey-900 font-[500] text-[18px] pb-[20px]">{selectedNotification?.title}</p>
                <p className="text-grey-600 font-[500] text-[16px] pb-[20px]">{selectedNotification?.body}</p>
                
            </ModalContainer> }

        </div>
    )

}
export default NotificationsCenterPage;